import Enum from "../../../../../enums/Enum";

const EnumInsuranceReferralType = new Enum({ //todo: refactor, replace with EnumDirectBillingType
            REFERRAL: {name: "Referral"},
            CONSULTATION: {name: "Consultation"},
            PROCEDURE: {name: "Procedure"},
            VALIDITY_EXTENSION: {name: "Validity Extension"},
            ADDITIONAL_SESSIONS: {name: "Additional Sessions"},

            PHYSIOTHERAPIST: {name: "Physiotherapy"},
            CHIROPRACTOR: {name: "Chiropractic"},
            OSTEOPATH: {name: "Osteopathy"},
            KINESIOLOGY: {name: "Kinesiology"},//todo KINESIOLOGY -> KINESIOLOGIST
            SPORTS_FAMILY_MEDICINE: {name: "Sports and Family Medicine Specialist"},
            FAMILY_MEDICINE: {name: "Family Medicine Specialist"},
            SPORTS_THERAPIST: {name: "Sports Therapist"},
            MOVEMENT_THERAPIST: {name: "Movement Therapist"},
            PHYSIATRIST: {name: "Physiatrist"},
            NURSE: {name: "Nurse"},
            ORTHOPEDIC_SURGERY_SPECIALIST: {name: "Orthopedic Surgery - Specialist"},
            CLINICAL_PSYCHOLOGIST: {name: "Clinical Psychologist"},
            FAMILY_MEDICINE_CONSULTANT: {name: "Family Medicine Consultant"},
            MASSAGE_THERAPIST: {name: "Massage Therapist"},
            ORTHOPEDIC_SURGERY_CONSULTANT: {name: "Orthopedic Surgery - Consultant"}
    }
)

export default EnumInsuranceReferralType;